"use client";

import { useLayoutEffect } from "react";

export const ScrollToTop = () => {
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);
  return null;
};
